import React, { useState, useEffect } from 'react';
import Plotly from 'plotly.js-dist-min';
import { ToggleSwitch } from '../../atoms';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
import { default as t } from '../../../utils/i18n';
import './attribute-details-modal.scss';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/Download-icon.svg';
import config from '../../../utils/config';
import axiosStat from 'axios';
import axios from '../../../utils/axios';
import fileDownload from 'js-file-download';

const AttributeDetailModal = props => {
  const HELP_SUPPORT_LINK = config.get('help', 'support_link');
  const [graphViewToggle, setGraphViewToggle] = useState(false);
  const [attributeDetailModalView, setAttributeDetailModalView] = useState(false);
  const [snapshotDownloading, setSnapshotDownloading] = useState(false);
  const [displaygraph, setDisplayGraph] = useState(true);
  const [downloadButtonClicked, setDownoadButtonClicked] = useState(false);
  const isEffectiveness = props?.insightDetails?.isEffectiveness;
  const isVolume = props?.insightDetails?.isVolume;
  const isBLSKpi = props?.insightDetails?.isBLSKpi;
  const catBasicEffect = t('cat.basic.effect');
  const catAdvanceEffect = t('cat.adv.effect');
   const catBasicVolume = t('cat.basic.vol') ;
   const catAdvanceVolume = t('cat.adv.vol');
    const contBasicEffect= t('cont.basic.effect');
    const contAdvanceEffect = t('cont.adv.effect');
    const contBasicVolume = t('cont.basic.vol');
    const contAdvanceVolume = t('cont.adv.vol');
    const legendBasicVolume = t('legend.basic');
    const legendAdvanceVolume = t('legend.adv.vol');
    const legendBasicEffect = t('legend.basic.effec');
    const legendAdvanceEffect = t('legend.adv.vol');
    const colours = Array(500)
    .fill(null)
    .map((_, idx) => idx);
  const regessionLayout1 = {
    title: {
      x: 0,
      text: t('details.attribute.graph.zoom.instruction'),
      font: {
        family: 'Gotham Narrow Medium , arial, sans-serif',
        color: '#000000',
        size: 14,
      },
    },
    hovermode: 'x unified',
    autosize: true,
    margin: { b: 80, l: 80, r: 30, t: 75 },
    autosize: true,
    margin: {
      b: 80,
      l: 80,
      r: 30,
      t: 75,
    },
    shapes: [
      // {
      //   editable: false,
      //   layer: 'below',
      //   xref: 'x',
      //   yref: 'paper',
      //   x0: 0,
      //   x1: 5,
      //   y0: 0,
      //   y1: 1,
      //   type: 'rect',
      //   fillcolor: '#BDDEBD',
      //   opacity: 0.8,
      //   line: {
      //     width: 0,
      //   },
      // },
      // {
      //   layer: 'below',
      //   xref: 'x',
      //   yref: 'paper',
      //   x0: 9,
      //   x1: 14,
      //   y0: 0,
      //   y1: 1,
      //   type: 'rect',
      //   fillcolor: '#FAECB2',
      //   line: {
      //     width: 0,
      //   },
      // },
      // {
      //   layer: 'below',
      //   xref: 'x',
      //   yref: 'paper',
      //   x0: 14,
      //   x1: 18,
      //   y0: 0,
      //   y1: 1,
      //   type: 'rect',
      //   fillcolor: '#F6D1C7',
      //   line: {
      //     width: 0,
      //   },
      // },
    ],
    xaxis: {
      title: '<b>Adset Duration/Weeks</b>',
      auto_generated_title: 'Perimeter (m)',
      zerolinecolor: 'red',
      zerolinewidth: 2,
    },
    yaxis: {
      title: '<b>Impact on cost (%)</b>',
      auto_generated_title: 'Impact on cost (%)',
      zerolinecolor: 'red',
      zerolinewidth: 2,
    },
  };

  const regessionLayout2 = {
    title: {
      x: 0,
      text: t('details.attribute.graph.zoom.instruction'),
      font: {
        family: 'Gotham Narrow Medium , arial, sans-serif',
        color: '#000000',
        size: 14,
      },
    },
    hovermode: 'x unified',
    autosize: true,
    margin: { b: 80, l: 80, r: 30, t: 75 },
    showlegend: false,
    autosize: true,
    margin: {
      b: 80,
      l: 80,
      r: 30,
      t: 75,
    },
    xaxis: {
      title: '<b>S&P: Adset Frequency Weekly</b>',
      auto_generated_title: 'S&P: Adset Frequency Weekly',
      zerolinecolor: 'red',
      zerolinewidth: 2,
    },
    yaxis: {
      title: '<b>Impact on cost (%)</b>',
      auto_generated_title: 'Impact on cost (%)',
      zerolinecolor: 'red',
      zerolinewidth: 2,
    },
  };

  const violinLayout1 = {
    hovermode: 'x unified',
    hoverinfo: 'none',
    autosize: true,
    margin: {
      b: 45,
      l: 80,
      r: 30,
      t: 150,
    },
    xaxis: {
      title: {
        text: '<b>Buying and optimisation- Adset Optimisation Goal</b>',
        standoff: 20,
      },
      auto_generated_title: 'Buying and optimisation- Adset Optimisation Goal',
      showgrid: false,
      zeroline: false,
      tickangle: 270,
      side: 'top',
      automargin: true,
    },
    yaxis: {
      title: {
        text: '<b>Impact on cost (%)</b>',
        standoff: 20,
      },
      showline: false,
      zerolinecolor: 'red',
      zerolinewidth: 2,
      automargin: true,
    },
  };

  const violinLayout2 = {
    hovermode: true,
    hoverinfo: 'none',
    autosize: true,
    margin: {
      b: 15,
      l: 10,
      r: 20,
      t: 150,
    },
    xaxis: {
      title: {
        text: '<b>Buying and optimisation- Adset Optimisation Goal</b>',
        standoff: 20,
      },
      auto_generated_title: 'Buying and optimisation- Adset Optimisation Goal',
      tickangle: 270,
      side: 'top',
      automargin: true,
    },
    yaxis: {
      title: {
        text: '<b>Impact on cost (%)</b>',
        standoff: 10,
        font: {
          size: 15,
        },
      },
      zerolinecolor: 'red',
      zerolinewidth: 2,
      automargin: true,
    },
  };
  const regessionOptions = {
    editable: false,
    displaylogo: false,
    displayModeBar: false,
    scrollZoom: false,
    showLink: false,
    modeBarButtonsToRemove: [
      'sendDataToCloud',
      'zoom2d',
      'pan',
      'pan2d',
      'autoScale2d',
      'lasso2d',
      'autoScale2d',
      'resetScale2d',
      'toggleSpikelines',
      'dragmode',
    ],
  };

  const violinOptions = {
    editable: false,
    displaylogo: false,
    displayModeBar: false,
  };
  const regessionTrace1 = {
    x: null,
    y: null,
    type: 'scatter',
    mode: 'lines',
    line: {
      width: 3,
      color: '#132874',
    },
    hovertemplate:
      '%{yaxis.title.text}: %{y:.2f}<br>' + '%{xaxis.title.text}: %{x}<br><extra></extra>',
  };
  const regessionTrace2 = {
    x: null,
    y: null,
    mode: 'markers',
    opacity: 0.5,
    marker: {
      color: colours,
      colorscale: 'Viridis',
      size: 5,
    },
    type: 'scatter',
    hovertemplate:
      '%{yaxis.title.text}: %{y:.2f}<br>' + '%{xaxis.title.text}: %{x}<br><extra></extra>',
  };

  const violinTrace1 = {
    x: null,
    y: null,
    mode: 'markers',
    name: 'North America',
    hoverinfo: 'none',
    marker: {
      color: 'rgb(164, 194, 244)',
      size: 12,
    },
    type: 'scatter',
    hovertemplate:	
    "%{yaxis.title.text}: %{y:.2f}<br>" +	
    "%{xaxis.title.text}: %{x}<br><extra></extra>",
  };
  
  const violinTrace2 = {
    type: 'violin',
    x: null,
    y: null,
    points: 'none',
    hoverinfo: 'none',
    box: {
      visible: false,
    },
    meanline: {
      visible: false,
    },
    medianline: {
      visible: true,
    },
    transforms: [
      {
        type: 'groupby',
      },
    ],
    // commented to hide graph hover.
    // hovertemplate:	
    // "%{yaxis.title.text}: %{y:.2f}<br>" +	
    // "%{xaxis.title.text}: %{x}<br><extra></extra>",
  };

  const handleBackClick = () => {
    document.body.style.overflow = 'auto';
    setGraphViewToggle(false);
    setTimeout(() => {
      props.handleModalBackClick();
    }, 1000);
    setAttributeDetailModalView(!attributeDetailModalView);
  };

  const handleToggle = () => {
    setGraphViewToggle(!graphViewToggle);
  };
  const handleDownload = (url, filename) => {
    const userGuideUrl = url.replace(/\{(.*?)\}/gi, t('dashboard.link.helpAndSupport', true));
    const api = axiosStat.create({
      baseURL: axios.defaults.baseURL.slice(0, -4),
    });
    api
      .get(userGuideUrl, {
        responseType: 'blob',
      })
      .then(res => {
        fileDownload(res.data, filename);
      });
  };

  const handleDownloadModalSSClick = () => {
    setDownoadButtonClicked(true);
    const icon = document.querySelector('.download-modal-icon');
    icon.classList.add('active');

    const fileName = `${props.insightDetails.data.campaign_attribute_type}_${
      props.insightDetails.data.visualisation_type === 'regression_line'
        ? graphViewToggle
          ? t('details.attribute.graph.regression.advance')
          : t('details.attribute.graph.regression.basic')
        : graphViewToggle
        ? t('details.attribute.graph.violin.advance')
        : t('details.attribute.graph.violin.basic')
    }`;
    var testdiv = document.getElementById('modal-snapshot-container');
    html2canvas(testdiv, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight, // There is no deviation from the top so there is no need to modify
      backgroundColor: '#F3F3F3',
      allowTaint: true,
      useCORS: true,
    }).then(canvas => {
      const image = canvas.toDataURL('image/jpeg', 1.0);
      const doc = new jsPdf('p', 'px', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const widthRatio = pageWidth / canvas.width;
      const heightRatio = pageHeight / canvas.height;
      const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

      const canvasWidth = canvas.width * ratio;
      const canvasHeight = canvas.height * ratio;

      const marginX = (pageWidth - canvasWidth) / 2;
      const marginY = (pageHeight - canvasHeight) / 2;

      doc.addImage(image, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
      doc.save(`${fileName}.pdf`);
      icon.classList.remove('active');
      setDownoadButtonClicked(false);
    });
  };

  const getHighlightIndicatorIndex = value => {
    for (let index = 0; index < props?.insightDetails?.data?.reliability_boundaries?.length; index++) {
      if (
        value >= props?.insightDetails?.data?.reliability_boundaries[index]?.x_start &&
        value <= props?.insightDetails?.data?.reliability_boundaries[index]?.x_end
      ) {
        return index;
      }
    }
  };

  useEffect(() => {
    if (props.insightDetails.data.visualisation_type === 'regression_line') {
      regessionTrace1.x = props.insightDetails.data.overview_data?.campaign_attribute;
      if(isEffectiveness) {
        regessionLayout1.yaxis.title = '<b>' + 'Impact on effectiveness (%)' + '</b>';
      } if(isVolume) {
        regessionLayout1.yaxis.title = '<b>' + 'Impact on volume (%)' + '</b>';
      }
      if(isBLSKpi) {
        regessionTrace1.y = props.insightDetails.data.overview_data?.kpi;
        regessionLayout1.yaxis.title ='<b>' + props.insightDetails.kpi + '</b>'
      } else {
        regessionTrace1.y = props.insightDetails.data.overview_data?.shap;
      }
      regessionLayout1.xaxis.title = '<b>' + props.insightDetails?.data.title + '</b>';
      props.insightDetails.data?.impact_boundaries?.map(index => {
        regessionLayout1?.shapes?.push({
          layer: 'below',
          xref: 'x',
          yref: 'paper',
          x0: index.x_start,
          x1: index.x_end,
          y0: 0,
          y1: 1,
          type: 'rect',
          fillcolor:
            index.impact === '0' ? '#FAECB2' : index.impact === '-1' ? '#F6D1C7' : '#BDDEBD',
          line: {
            width: 0,
          },
        });
      });
      if (regessionLayout1?.shapes && props.insightDetails.data?.impact_boundaries) {
        regessionLayout1.shapes[1].x0 = props.insightDetails.data?.impact_boundaries[1]?.x_start;
        regessionLayout1.shapes[1].x1 = props.insightDetails.data?.impact_boundaries[1]?.x_end;
        if(regessionLayout1.shapes[2]) {
          regessionLayout1.shapes[2].x0 = props.insightDetails.data?.impact_boundaries[2]?.x_start;
          regessionLayout1.shapes[2].x1 = props.insightDetails.data?.impact_boundaries[2]?.x_end;
        }
      }
      regessionTrace2.x = props.insightDetails.data.raw_sample_500.campaign_attribute;
      if(isEffectiveness) {
        regessionLayout2.yaxis.title = '<b>' + 'Impact on effectiveness (%)' + '</b>';
      } if(isVolume) {
        regessionLayout2.yaxis.title = '<b>' + 'Impact on volume (%)' + '</b>';
      }
      if(isBLSKpi) {
        regessionTrace2.y = props.insightDetails.data.raw_sample_500.kpi;
        regessionLayout2.yaxis.title = '<b>' + props.insightDetails.kpi + '</b>';
      } else {
        regessionTrace2.y = props.insightDetails.data.raw_sample_500.shap;
      }
      regessionLayout2.xaxis.title = '<b>' + props.insightDetails.data.title + '</b>';
      const data = [regessionTrace1];
      let data1 = [];
      if(!isBLSKpi) {
         Plotly.newPlot('basic-view', data, regessionLayout1, regessionOptions, { responsive: true });
         Plotly.newPlot('ss-basic-view', data, regessionLayout1, regessionOptions, {
          responsive: true,
        });
        data1 = [regessionTrace2, regessionTrace1]
      } else {
        setGraphViewToggle(true);
        regessionTrace2.marker =  {
          color: 'rgb(164, 194, 244)',
          size: 12,
        };
        data1 = [regessionTrace2];
      }
      Plotly.newPlot('advance-view', data1, regessionLayout2, regessionOptions, {
        responsive: true,
      });

      const continuousGraph = document.getElementById('advance-view');

      continuousGraph.on('plotly_hover', function (e) {
        const indexValue = getHighlightIndicatorIndex(e.points[0].x);
        const matchingIndicatorGraph = document.getElementById(
          `reliability-indicator-${indexValue}`
        );

        if (matchingIndicatorGraph?.firstChild) {
          if (indexValue > 2 && indexValue % 3 == 0 ) {
            document
              .getElementById('indicators-container')
              .scrollTo({ left: indexValue % 3 == 0 ? 650 * indexValue / 3 : 600 , behavior: 'smooth' });
          } else {
            document
              .getElementById('indicators-container')
              .scrollTo({ left: indexValue > 1 ? 650 * indexValue / 4 : -400, behavior: 'smooth' });
          }
          matchingIndicatorGraph.firstChild.firstChild.className = 'highlighted-indicator';
          matchingIndicatorGraph.firstChild.firstChild.firstChild.style.border = '1px solid gray';
        }
      });

      continuousGraph.on('plotly_unhover', function (e) {
        const indexValue = getHighlightIndicatorIndex(e.points[0].x);
        const matchingIndicatorGraph = document.getElementById(
          `reliability-indicator-${indexValue}`
        );
        if (matchingIndicatorGraph?.firstChild) {
          matchingIndicatorGraph.firstChild.firstChild.classList.remove('highlighted-indicator');
          matchingIndicatorGraph.firstChild.firstChild.firstChild.style.border = 'none';
        }
      });

      Plotly.newPlot('ss-advance-view', data1, regessionLayout2, regessionOptions, {
        responsive: true,
      });
    } else {
      violinTrace1.x = props.insightDetails.data?.overview_data?.campaign_attribute;
      violinTrace1.y = props.insightDetails.data?.overview_data?.median;
      violinLayout1.xaxis.title.text = '<b>' + props.insightDetails.data.title + '</b>';
      violinTrace2.x = props.insightDetails.data.raw_sample_500?.campaign_attribute;
      if(isEffectiveness) {
        violinLayout1.yaxis.title.text = '<b>' + '&nbsp;&nbsp;&nbsp;Impact on effectiveness (%)' + '</b>';
        violinLayout2.yaxis.title.text = '<b>' + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Impact on effectiveness (%)' + '</b>';
      } if(isVolume) {
        violinLayout1.yaxis.title.text = '<b>' + 'Impact on volume (%)' + '</b>';
        violinLayout2.yaxis.title.text = '<b>' + 'Impact on volume (%)' + '</b>';
      }
      if(isBLSKpi) {
        console.log(props.insightDetails.kpi,'props.insightDetails.kpi');
        violinTrace2.y = props.insightDetails.data.raw_sample_500?.kpi;
        violinLayout1.yaxis.title.text = '<b>' + props.insightDetails.kpi + '</b>';
        violinLayout2.yaxis.title.text = '<b>' + props.insightDetails.kpi + '</b>';
      } else {
        violinTrace2.y = props.insightDetails.data.raw_sample_500?.shap;
      }
      violinLayout2.xaxis.title.text = '<b>' + props.insightDetails.data.title + '</b>';

      const data = [violinTrace1];
      Plotly.newPlot('basic-view', data, violinLayout1, violinOptions, { showSendToCloud: true });
      Plotly.newPlot('ss-basic-view', data, violinLayout1, violinOptions, {
        showSendToCloud: true,
      });
      const data1 = [violinTrace2];
      Plotly.newPlot('advance-view', data1, violinLayout2, violinOptions, {
        showSendToCloud: true,
      });

      var myPlot = document.getElementById('advance-view');
      myPlot.on('plotly_hover', function (e) {
        const matchingIndicatorGraph = document.getElementById(
          `reliability-indicator-${e.points[0].pointIndex}`
          );
          if (matchingIndicatorGraph) {
            if (e.points[0].pointIndex > 2 && e.points[0].pointIndex % 3 == 0 ) {
              document
              .getElementById('indicators-container')
              .scrollTo({ left: e.points[0].pointIndex % 3 == 0 ? 650 * e.points[0].pointIndex / 3 : 600 , behavior: 'smooth' });
            } else {
              document
              .getElementById('indicators-container')
              .scrollTo({ left: e.points[0].pointIndex > 1 ? 650 * e.points[0].pointIndex / 4 : -400, behavior: 'smooth' });
            }
          matchingIndicatorGraph.firstChild.firstChild.className = 'highlighted-indicator';
          matchingIndicatorGraph.firstChild.firstChild.firstChild.style.border = '1px solid gray';
        }
      });

      myPlot.on('plotly_unhover', function (e) {
        const matchingIndicatorGraph = document.getElementById(
          `reliability-indicator-${e.points[0].pointIndex}`
        );
        if (matchingIndicatorGraph) {
          matchingIndicatorGraph.firstChild.firstChild.classList.remove('highlighted-indicator');
          matchingIndicatorGraph.firstChild.firstChild.firstChild.style.border = 'none';
        }
      });

      Plotly.newPlot('ss-advance-view', data1, violinLayout2, violinOptions, {
        showSendToCloud: true,
      });
    }
  }, [graphViewToggle]);

  useEffect(() => {
    if (
      props.insightDetails.data?.reliability_boundaries ||
      props.insightDetails.data.overview_data?.reliability_advanced
    ) {
      if (indicatorProvenInsight[0] !== 30 && graphViewToggle) {
        if (props.insightDetails.data.visualisation_type === 'violin_plot') {
          [...new Set(props.insightDetails.data.overview_data.campaign_attribute)].map(
            (attribute, index) => {
              let reliability = props.insightDetails.data.overview_data.reliability_advanced[index];
              indicatorPlot(reliability, index);
            }
          );
        } else {
          props.insightDetails.data?.reliability_boundaries.map((reliabilityValue, index) => {
            if (reliabilityValue?.reliability != undefined) {
              indicatorPlot(reliabilityValue?.reliability, index);
            }
          });
        }
      }
      indicatorProvenInsight.map(
        value => indicatorPlot(value, 'basic', { t: 0, r: 0, l: 0, b: 0 }, 130, 130),
        'transparent'
      );
    } else {
      setDisplayGraph(false);
    }
  }, [graphViewToggle, downloadButtonClicked]);

  useEffect(() => {
    setAttributeDetailModalView(true);
    document.body.style.overflow = 'hidden';
    props.insightDetails.data.about_this_insight = props.insightDetails.data.about_this_insight
      ?.replace(/'(.*?)'/g, function myFunction(x) {
        x = '<span>' + x + '</span>';
        return x;
      })
      .replaceAll("'", '');
  }, []);

  // reliability Indicator code starts ------------------------------------>
  let indicatorProvenInsight = [props.insightDetails.data.reliability_basic ?? 30];

  const indicatorData = [
    {
      type: 'indicator',
      mode: 'gauge+number',
      value: 3,
      number: {
        font: { size: 1 },
      },
      gauge: {
        axis: { range: [0, 10], showticklabels: false, visible: false },
        bar: { color: 'white', line: { width: 0 }, thickness: 0 },
        borderwidth: 0,
        steps: [
          { range: [0, 3.33], color: '#F3674A' },
          { range: [3.33, 6.66], color: '#FFC000' },
          { range: [6.66, 10], color: '#269325' },
        ],
        threshold: {
          thickness: 0,
        },
      },
    },
  ];

  const indicatorArrowValue = [
    {
      index: 0,
      theta: 0,
      ax: -0.5,
      ay: 2.7,
      x: 1.5,
      y: 2.7,
      r: 0,
    },
    {
      index: 1,
      theta: 18,
      ax: -0.2,
      ay: 4,
      x: 0.7,
      y: 3.1,
      r: 1,
    },
    {
      index: 2,
      theta: 36,
      ax: 0.6,
      ay: 5.7,
      x: 1.5,
      y: 4,
      r: 1,
    },
    {
      index: 3,
      theta: 54,
      ax: 1.6,
      ay: 6.9,
      x: 2.4,
      y: 4.5,
      r: 1,
    },
    {
      index: 4,
      theta: 72,
      ax: 3.3,
      ay: 8.1,
      x: 3.7,
      y: 4.8,
      r: 1,
    },
    {
      index: 5,
      theta: 90,
      ax: 5,
      ay: 8.3,
      x: 5,
      y: 4.9,
      r: 1,
    },
    {
      index: 6,
      theta: 108,
      ax: 6.7,
      ay: 8.1,
      x: 6.3,
      y: 4.8,
      r: 1,
    },
    {
      index: 7,
      theta: 126,
      ax: 8.3,
      ay: 6.9,
      x: 7.6,
      y: 4.5,
      r: 1,
    },
    {
      index: 8,
      theta: 144,
      ax: 9.5,
      ay: 5.7,
      x: 8.5,
      y: 4,
      r: 1,
    },
    {
      index: 9,
      theta: 162,
      ax: 10.2,
      ay: 4.2,
      x: 9.2,
      y: 3.2,
      r: 1,
    },
    {
      index: 10,
      theta: 180,
      ax: 10.5,
      ay: 2.6,
      x: 9.4,
      y: 2.6,
      r: 1,
    },
  ];

  const indicatorLayoutOptions = {
    editable: false,
    displaylogo: false,
    displayModeBar: false,
    captureevents: true,
    scrollZoom: true,
    staticPlot: true,
  };

  const indicatorLayout = {
    width: 150,
    height: 150,
    hovermode: true,
    margin: { t: 20, r: 20, l: 20, b: 20 },
    xaxis: { range: [0, 10], showgrid: false, zeroline: false, visible: false },
    yaxis: { range: [0, 10], showgrid: false, zeroline: false, visible: false },
    showlegend: false,
    legend: {
      bgcolor: '#8B7437',
    },
    annotations: [
      {
        ax: 0,
        ay: 0,
        axref: 'x',
        ayref: 'y',
        x: 0,
        y: 0,
        xref: 'x',
        yref: 'y',
        borderpad: 0,
        arrowsize: 0.3,
        arrowhead: 6,
        arrowwidth: 6,
        arrowside: 'end+start',
      },
    ],
  };

  const indicatorPlot = (reliabilityValue, index, margin, width, height, bgcolor) => {
    let theta = indicatorArrowValue[reliabilityValue]?.theta;
    let r = indicatorArrowValue[reliabilityValue]?.r;
    let x_head = r * Math.cos((Math.PI / 180) * theta);
    let y_head = r * Math.sin((Math.PI / 180) * theta);

    indicatorLayout.annotations[0].ax = indicatorArrowValue[reliabilityValue]?.ax;
    indicatorLayout.annotations[0].ay = indicatorArrowValue[reliabilityValue]?.ay;
    indicatorLayout.annotations[0].x = indicatorArrowValue[reliabilityValue]?.x + x_head;
    indicatorLayout.annotations[0].y = indicatorArrowValue[reliabilityValue]?.y + y_head;

    indicatorLayout.margin = margin ? margin : { t: 20, r: 20, l: 20, b: 20 };
    indicatorLayout.width = width ? width : 150;
    indicatorLayout.height = height ? height : 150;
    indicatorLayout.legend.bgcolor = bgcolor ? bgcolor : 'transparent';

    let id = 'reliability-indicator-' + index;
    Plotly.newPlot(id, indicatorData, indicatorLayout, indicatorLayoutOptions);

    let download_id = 'reliability-indicator-download' + index;
    Plotly.newPlot(download_id, indicatorData, indicatorLayout, indicatorLayoutOptions);
  };

  // reliability Indicator code ends  ------------------------------------->

  const checkisString = val => {
    return isNaN(Number(val)) ? 1 : 0;
  };

  return (
    <>
      {/* slide modal view starts */}
      <div
        className={`attribute-detail-view-overlay ${attributeDetailModalView ? 'show' : 'hide'}`}
      >
        <div className="attribute-detail-view">
          <div className="attribute-detail-view-header">
            <span className="attribute-detail-view-headertext">
              {t('download.pdf.info.question')}
            </span>
            <button
              className="download-snapshot"
              onClick={() => {
                handleDownload(HELP_SUPPORT_LINK, 'help.pdf');
              }}
            >
              <i className="eva eva-message-circle-outline"></i>
              {t('download.pdf.button.label')}
            </button>
          </div>
          <div className="attribute-detail-view-buttongroup">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('user.buttonText.back')}
            </button>
            <DownloadIcon className="download-modal-icon" />
            <button className="download-snapshot" onClick={() => handleDownloadModalSSClick()}>
              <i className="eva eva-camera-outline"></i>
              {t('download.snapshot.button.label')}
            </button>
          </div>
          <div className="attribute-detail-view-title">
            <span className="serial">{props.insightDetails.index}</span>
            <span className="title-text">{props.insightDetails.data.title}</span>
          </div>

          <div className="attribute-detail-view-summarygroup">
            <div className="distribute-1-3 attribute-detail-view-summarygroup-item">
              <div className="summarygroup-item">
                <div className="summarygroup-item-title">
                  {t('detail.attribute.listing.thead.category')}
                </div>
                <div className="summarygroup-item-text">{props.insightDetails.data.category}</div>
              </div>
            </div>
            <div className="distribute-1-3 attribute-detail-view-summarygroup-item">
              <div className="summarygroup-item">
                <div className="summarygroup-item-title">
                  {t('detail.attribute.listing.thead.selectedKPI')}
                </div>
                <div className="summarygroup-item-text">{props.insightDetails.kpi}</div>
              </div>
            </div>
            <div className="distribute-1-3 attribute-detail-view-summarygroup-item">
              <div className="summarygroup-item distribute-2-3 custom-width-2-3">
                <div className="summarygroup-item-title">
                {t(isBLSKpi ? 'Observational insights' : 'detail.attribute.modal.thead.reliability')}
                </div>
                {!isBLSKpi ? 
                <div className="summarygroup-item-text">
                  {t('detail.attribute.modal.tbody.pinsight')}
                </div> : ''
                }
              </div>

              {/* This is for creating realibility indicator on the top-right position */}

              { !isBLSKpi && 
               <div className="summarygroup-item distribute-1-3 custom-width-1-3">
                <div className={!graphViewToggle ? 'basic-view' : 'basic-view'}>
                  {indicatorProvenInsight.map(value => {
                    if (
                      props.insightDetails.data.visualisation_type === 'violin_plot' ||
                      props.insightDetails.data.visualisation_type === 'regression_line'
                    ) {
                      const reliability_advanced = value;
                      let reliability_value = '';
                      let reliability_bg_color = '';
                      let margin_left = '';
                      if (reliability_advanced <= 3) {
                        reliability_value = t(
                          'details.attribute.graph.detail.indicator.reliability.low'
                        );
                        reliability_bg_color = '#F3674A';
                        margin_left = '-8px';
                      } else if (4 <= reliability_advanced && reliability_advanced <= 6) {
                        reliability_value = t(
                          'details.attribute.graph.detail.indicator.reliability.medium'
                        );
                        reliability_bg_color = '#FFC000';
                        margin_left = '-18px';
                      } else if (7 <= reliability_advanced) {
                        reliability_value = t(
                          'details.attribute.graph.detail.indicator.reliability.high'
                        );
                        reliability_bg_color = '#269325';
                        margin_left = '-9px';
                      }
                      return displaygraph ? (
                        <div className="reliability-indicator-basic-class">
                          <div id="reliability-indicator-basic"></div>
                          <div className="reliability-value">
                            <div
                              className="reliability-badge"
                              style={{ background: reliability_bg_color }}
                            >
                              {reliability_advanced}
                            </div>
                            <div className="reliability-p" style={{ marginLeft: margin_left }}>
                              <p>{reliability_value}</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="not-available-message">
                          <p>{t('attr.details.not.available')}*</p>
                          <p>*{t('attr.details.review.reliability')}</p>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>}
            </div>
          </div>

          <div className="attribute-detail-view-data">
            <div className="distribute-1-3">
              {!isBLSKpi &&  <div className="attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item-title">
                  {t('detail.attribute.modal.optimumrange.label')}
                </div>
                <div className="average-cost">
                  <span
                    className={`percentage ${
                      checkisString(props.insightDetails?.data?.recommendation?.value) ? 'str' : ''
                    }`}
                  >
                    {props.insightDetails?.data?.recommendation?.value}
                  </span>
                </div>
              </div> }
              <div className="attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item-title">
                  {t('detail.attribute.modal.about.insight')}
                </div>
                <div
                  className="insight-text"
                  dangerouslySetInnerHTML={{ __html: props.insightDetails.data.about_this_insight }}
                ></div>
              </div>
            </div>
            <div className="distribute-2-3">
              <div className="attribute-detail-view-summarygroup-item">
                <div className="graph-view-heading">
                  <span className="graph-type">
                    {props.insightDetails.data.campaign_attribute_type}:{' '}
                    {props.insightDetails.data.visualisation_type === 'regression_line'
                      ? graphViewToggle
                        ? t('details.attribute.graph.regression.advance')
                        : t('details.attribute.graph.regression.basic')
                      : graphViewToggle
                      ? t('details.attribute.graph.violin.advance')
                      : t('details.attribute.graph.violin.basic')}
                  </span>
                  {isBLSKpi && props.insightDetails.data.visualisation_type === 'regression_line' ? '' : <ToggleSwitch
                    id="toggle-graph"
                    checked={graphViewToggle}
                    onToggle={handleToggle}
                    disabled={false}
                    optionLabels={[
                      t('detailgraph.toggle.basic.label'),
                      t('detailgraph.toggle.advance.label'),
                    ]}
                  /> }
                  
                </div>
                <div className="graph-view">
                  <span
                    className={
                      props.insightDetails.data.visualisation_type === 'violin_plot' ? '' : 'hidden'
                    }
                  >
                    {t('details.attribute.graph.zoom.instruction')}
                  </span>
                  <div id="basic-view" className={graphViewToggle ? 'hidden' : ''}></div>
                  <div id="advance-view" className={!graphViewToggle ? 'hidden' : ''}></div>
                </div>
                <div
                  className={
                    props.insightDetails.data.visualisation_type === 'violin_plot' &&
                    graphViewToggle &&
                    indicatorProvenInsight[0] !== 30
                      ? 'yaxis-title'
                      : 'hidden'
                  }
                >
                  {t('details.attribute.graph.detail.indicator.reliability')}
                </div>
                <div
                  className={
                    props.insightDetails.data.visualisation_type === 'regression_line' &&
                    graphViewToggle &&
                    indicatorProvenInsight[0] !== 30
                      ? 'yaxis-title-regression'
                      : 'hidden'
                  }
                >
                  {t('details.attribute.graph.detail.indicator.reliability')}
                </div>
                {graphViewToggle && displaygraph ? (
                  <div
                    id="indicators-container"
                    className={
                      props.insightDetails.data.visualisation_type === 'violin_plot'
                        ? 'indicator-reliability'
                        : 'indicator-reliability-regression'
                    }
                  >
                    {props.insightDetails.data.visualisation_type === 'regression_line' &&
                    graphViewToggle
                      ? props.insightDetails.data.reliability_boundaries.map(
                          (reliabilityData, index) => {
                            const reliability_advanced = reliabilityData?.reliability;
                            const reliabilityRangeStart = reliabilityData?.x_start
                              ?.toFixed(3)
                              .slice(0, -1);
                            const reliabilityRangeEnd = reliabilityData?.x_end
                              ?.toFixed(3)
                              .slice(0, -1);

                            let reliability_value = '';
                            let reliability_bg_color = '';
                            let margin_left = '';
                            if (reliability_advanced <= 3) {
                              reliability_value = t(
                                'details.attribute.graph.detail.indicator.reliability.low'
                              );
                              reliability_bg_color = '#F3674A';
                              margin_left = '3px';
                            } else if (4 <= reliability_advanced && reliability_advanced <= 6) {
                              reliability_value = t(
                                'details.attribute.graph.detail.indicator.reliability.medium'
                              );
                              reliability_bg_color = '#FFC000';
                              margin_left = '-9px';
                            } else if (7 <= reliability_advanced) {
                              reliability_value = t(
                                'details.attribute.graph.detail.indicator.reliability.high'
                              );
                              reliability_bg_color = '#269325';
                              margin_left = '1px';
                            }
                            return (
                              <div className="indicator-view">
                                <div className="indicator-title">
                                  {reliabilityRangeStart + ' - ' + reliabilityRangeEnd}
                                </div>
                                <div id={'reliability-indicator-' + index}></div>
                                <div className="reliability-value">
                                  <div
                                    className="reliability-badge"
                                    style={{ background: reliability_bg_color }}
                                  >
                                    {reliability_advanced}
                                  </div>
                                  <div
                                    className="reliability-p"
                                    style={{ marginLeft: margin_left }}
                                  >
                                    {reliability_value}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )
                      : null}
                    {props.insightDetails.data.visualisation_type === 'violin_plot' &&
                      graphViewToggle && (
                        <div className={'indicator-row'}>
                          {[
                            ...new Set(props.insightDetails.data.overview_data.campaign_attribute),
                          ].map((attribute, index) => {
                            if (
                              props.insightDetails.data.visualisation_type === 'violin_plot' &&
                              indicatorProvenInsight[0] !== 30
                            ) {
                              const reliability_advanced =
                                props.insightDetails.data.overview_data.reliability_advanced[index];

                              let reliability_value = '';
                              let reliability_bg_color = '';
                              let margin_left = '';
                              if (reliability_advanced <= 3) {
                                reliability_value = t(
                                  'details.attribute.graph.detail.indicator.reliability.low'
                                );
                                reliability_bg_color = '#F3674A';
                                margin_left = '3px';
                              } else if (4 <= reliability_advanced && reliability_advanced <= 6) {
                                reliability_value = t(
                                  'details.attribute.graph.detail.indicator.reliability.medium'
                                );
                                reliability_bg_color = '#FFC000';
                                margin_left = '-9px';
                              } else if (7 <= reliability_advanced) {
                                reliability_value = t(
                                  'details.attribute.graph.detail.indicator.reliability.high'
                                );
                                reliability_bg_color = '#269325';
                                margin_left = '1px';
                              }
                              return (
                                <div className="indicator-view">
                                  <div className="indicator-title">{attribute}</div>
                                  <div id={'reliability-indicator-' + index}></div>
                                  <div className="reliability-value">
                                    <div
                                      className="reliability-badge"
                                      style={{ background: reliability_bg_color }}
                                    >
                                      {reliability_advanced}
                                    </div>
                                    <div
                                      className="reliability-p"
                                      style={{ marginLeft: margin_left }}
                                    >
                                      {reliability_value}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      )}
                  </div>
                ) : null}
                <div className="graph-detail-view">
                  <h4>{t('details.attribute.graph.detail.heading')}</h4>
                  <p>
                    {t(
                      `details.attribute.graph.detail.desc.${
                        graphViewToggle ? 'advance' : 'basic'
                      }.${props.insightDetails.data.campaign_attribute_type}.desc1`
                    )}
                  </p>
                  <p>
                    <span className="heading">{t('details.attribute.graph.detail.xaxis')}</span>
                    {props.insightDetails.data.title}
                  </p>
                  <p>
                    <span className="heading">{t('details.attribute.graph.detail.yaxis')}</span>
                    {
                    isBLSKpi ? props.insightDetails.kpi :
                    t(isEffectiveness ? 'Predicted impact on the Effectiveness (%)' : isVolume ? 'Predicted impact on the Volume (%)' : 'details.attribute.graph.detail.yaxis.value')}
                  </p>
                  <p>
                    <span className="heading">{t('details.attribute.info.heading.impact')}</span>
                    <span>
                      {
                      isBLSKpi ? 
                      t(
                        props.insightDetails.data.campaign_attribute_type === 'continuous' ?
                        !graphViewToggle ? 
                         t('graph.view.toggle1')
                        : t('graph.view.toggle2')
                      : (
                        !graphViewToggle ? 
                        t('selected.dataset.toggle1')
                         : t('selected.dataset.toggle2')
                      )
                         )
                      :
                      isEffectiveness ? t(
                        props.insightDetails.data.campaign_attribute_type === 'continuous' ? 
                        (!graphViewToggle ? contBasicEffect : contAdvanceEffect) : (!graphViewToggle ? catBasicEffect : catAdvanceEffect)
                      ) : isVolume ? t(
                        props.insightDetails.data.campaign_attribute_type === 'continuous' ? 
                        (!graphViewToggle ? contBasicVolume : contAdvanceVolume) : (!graphViewToggle ? catBasicVolume : catAdvanceVolume)
                      ) 
                      :
                      t(
                        `details.attribute.graph.detail.desc.${
                          graphViewToggle ? 'advance' : 'basic'
                        }.${props.insightDetails.data.campaign_attribute_type}.desc2`
                      )}
                    </span>
                  </p>
                  {props.insightDetails.data.visualisation_type === 'regression_line' && (
                    !isBLSKpi &&
                    <p>
                      <span className="heading">{t('details.attribute.info.heading.legend')}</span>
                      <span>
                        {
                        isEffectiveness ? (
                          !graphViewToggle ? legendBasicEffect : legendAdvanceEffect
                        ) : isVolume ? (                          
                          !graphViewToggle ? legendBasicVolume : legendAdvanceVolume
                          ) :
                        t(
                          `details.attribute.graph.detail.desc.${
                            graphViewToggle ? 'advance' : 'basic'
                          }.${props.insightDetails.data.campaign_attribute_type}.desc3`
                        )}
                      </span>
                    </p>
                  )}
                  {((props.insightDetails.data.visualisation_type === 'regression_line' &&
                    (graphViewToggle || !graphViewToggle)) ||
                    (props.insightDetails.data.visualisation_type !== 'regression_line' &&
                      !graphViewToggle)) && (
                    <p className="tip">
                      <span className="heading">{t('details.attribute.info.heading.tip')}</span>
                      <span>
                        {t(
                          `details.attribute.graph.detail.desc.${
                            graphViewToggle ? 'advance' : 'basic'
                          }.${props.insightDetails.data.campaign_attribute_type}.tip`
                        )}
                      </span>
                    </p>
                  )}
                {!isBLSKpi &&  <p className="tip">
                    <span className="heading color-code-heading">
                      {t('details.attribute.info.heading.colorCodes')}
                    </span>
                    <div>
                      <div className="color-box-container">
                        <div className="color-box color-box-orange"> </div>
                        <span>0-3 | {t('graph.low')}</span>
                      </div>
                      <div className="color-box-container">
                        <div className="color-box color-box-yellow"></div>
                        <span>4-6 | {t('graph.medium')}</span>
                      </div>
                      <div className="color-box-container">
                        <div className="color-box color-box-green"> </div>
                        <span>7-10 | {t('graph.high')}</span>
                      </div>
                    </div>
                  </p> }
                </div>
              </div>
            </div>
          </div>

          <div id="modal-snapshot-container">
            <div className="attribute-detail-view-title">
              <span className="serial">{props.insightDetails.index}</span>
              <span className="title-text">{props.insightDetails.data.title}</span>
            </div>
            <div className="attribute-detail-view-summarygroup">
              <div className="distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">
                    {t('detail.attribute.listing.thead.category')}
                  </div>
                  <div className="summarygroup-item-text">{props.insightDetails.data.category}</div>
                </div>
              </div>
              <div className="distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">
                    {t('detail.attribute.listing.thead.selectedKPI')}
                  </div>
                  <div className="summarygroup-item-text">{props.insightDetails.kpi}</div>
                </div>
              </div>
              <div className="distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item distribute-2-3 custom-width-2-3">
                  <div className="summarygroup-item-title">
                    {t(isBLSKpi ? 'Observational insights' : 'detail.attribute.modal.thead.reliability')}
                  </div>
                  {!isBLSKpi ? 
                <div className="summarygroup-item-text">
                  {t('detail.attribute.modal.tbody.pinsight')}
                </div> : ''
                }
                </div>
                {!isBLSKpi && 
                  <div className="summarygroup-item distribute-1-3 custom-width-1-3">
                  <div className={!graphViewToggle ? 'basic-view' : 'basic-view'}>
                    {indicatorProvenInsight.map(value => {
                      if (
                        props.insightDetails.data.visualisation_type === 'violin_plot' ||
                        props.insightDetails.data.visualisation_type === 'regression_line'
                      ) {
                        const reliability_advanced = value;
                        let reliability_value = '';
                        let reliability_bg_color = '';
                        let margin_left = '';
                        if (reliability_advanced <= 3) {
                          reliability_value = t(
                            'details.attribute.graph.detail.indicator.reliability.low'
                          );
                          reliability_bg_color = '#F3674A';
                          margin_left = '-8px';
                        } else if (4 <= reliability_advanced && reliability_advanced <= 6) {
                          reliability_value = t(
                            'details.attribute.graph.detail.indicator.reliability.medium'
                          );
                          reliability_bg_color = '#FFC000';
                          margin_left = '-18px';
                        } else if (7 <= reliability_advanced) {
                          reliability_value = t(
                            'details.attribute.graph.detail.indicator.reliability.high'
                          );
                          reliability_bg_color = '#269325';
                          margin_left = '-9px';
                        }
                        return displaygraph ? (
                          <div className="reliability-indicator-basic-class-download">
                            <div id="reliability-indicator-downloadbasic"></div>
                            <div className="reliability-value">
                              <div
                                className="reliability-badge-download"
                                style={{ background: reliability_bg_color }}
                              >
                                <p>{reliability_advanced}</p>
                              </div>
                              <div className="reliability-p" style={{ marginLeft: margin_left }}>
                                <p>{reliability_value}</p>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="not-available-message">
                            <p>{t('attr.details.not.available')}*</p>
                            <p>*{t('attr.details.review.reliability')}</p>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
                }
              </div>
            </div>
            <div className="attribute-detail-view-data">
              <div className="distribute-1-3">
              {!isBLSKpi && 
                <div className="attribute-detail-view-summarygroup-item">
                  <div className="summarygroup-item-title">
                    {t('detail.attribute.modal.optimumrange.label')}
                  </div>
                  <div className="average-cost">
                    <span
                      className={`percentage ${
                        checkisString(props.insightDetails?.data?.recommendation?.value) ? 'str' : ''
                      }`}
                    >
                      {props.insightDetails?.data?.recommendation?.value}
                    </span>
                  </div>
                </div>
                }
                <div className="attribute-detail-view-summarygroup-item">
                  <div className="summarygroup-item-title">
                    {t('detail.attribute.modal.about.insight')}
                  </div>
                  <div
                    className="insight-text"
                    dangerouslySetInnerHTML={{
                      __html: props.insightDetails.data.about_this_insight,
                    }}
                  ></div>
                </div>
              </div>
              <div className="distribute-2-3">
                <div className="attribute-detail-view-summarygroup-item">
                  <div className="graph-view-heading">
                    <span className="graph-type">
                      {props.insightDetails.data.campaign_attribute_type}:{' '}
                      {props.insightDetails.data.visualisation_type === 'regression_line'
                        ? graphViewToggle
                          ? t('details.attribute.graph.regression.advance')
                          : t('details.attribute.graph.regression.basic')
                        : graphViewToggle
                        ? t('details.attribute.graph.violin.advance')
                        : t('details.attribute.graph.violin.basic')}
                    </span>
                    <ToggleSwitch
                      id="toggle-graph"
                      checked={graphViewToggle}
                      onToggle={handleToggle}
                      disabled={false}
                      optionLabels={[
                        t('detailgraph.toggle.basic.label'),
                        t('detailgraph.toggle.advance.label'),
                      ]}
                    />
                  </div>
                  <div className="graph-view">
                    <div id="ss-basic-view" className={graphViewToggle ? 'hidden' : ''}></div>
                    <div id="ss-advance-view" className={!graphViewToggle ? 'hidden' : ''}></div>
                  </div>

                  {graphViewToggle && displaygraph ? (
                    <div
                      id="indicators-container"
                      className={
                        props.insightDetails.data.visualisation_type === 'violin_plot'
                          ? 'indicator-reliability-download'
                          : 'indicator-reliability-regression'
                      }
                    >
                      {props.insightDetails.data.visualisation_type === 'regression_line' &&
                      graphViewToggle
                        ? props.insightDetails.data.reliability_boundaries.map(
                            (reliabilityData, index) => {
                              const reliability_advanced = reliabilityData?.reliability;
                              const reliabilityRangeStart = reliabilityData?.x_start
                                ?.toFixed(3)
                                .slice(0, -1);
                              const reliabilityRangeEnd = reliabilityData?.x_end
                                ?.toFixed(3)
                                .slice(0, -1);

                              let reliability_value = '';
                              let reliability_bg_color = '';
                              let margin_left = '';
                              if (reliability_advanced <= 3) {
                                reliability_value = t(
                                  'details.attribute.graph.detail.indicator.reliability.low'
                                );
                                reliability_bg_color = '#F3674A';
                                margin_left = '3px';
                              } else if (4 <= reliability_advanced && reliability_advanced <= 6) {
                                reliability_value = t(
                                  'details.attribute.graph.detail.indicator.reliability.medium'
                                );
                                reliability_bg_color = '#FFC000';
                                margin_left = '-9px';
                              } else if (7 <= reliability_advanced) {
                                reliability_value = t(
                                  'details.attribute.graph.detail.indicator.reliability.high'
                                );
                                reliability_bg_color = '#269325';
                                margin_left = '1px';
                              }
                              return (
                                <div className="indicator-view">
                                  <div className="indicator-title">
                                    {reliabilityRangeStart + ' - ' + reliabilityRangeEnd}
                                  </div>
                                  <div id={'reliability-indicator-download' + index}></div>
                                  <div className="reliability-value">
                                    <div
                                      className="reliability-badge"
                                      style={{ background: reliability_bg_color }}
                                    >
                                      {reliability_advanced}
                                    </div>
                                    <div
                                      className="reliability-p"
                                      style={{ marginLeft: margin_left }}
                                    >
                                      {reliability_value}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )
                        : null}
                      {props.insightDetails.data.visualisation_type === 'violin_plot' &&
                        graphViewToggle && (
                          <div className={'indicator-row-download'}>
                            {[
                              ...new Set(
                                props.insightDetails.data.overview_data.campaign_attribute
                              ),
                            ].map((attribute, index) => {
                              if (
                                props.insightDetails.data.visualisation_type === 'violin_plot' &&
                                indicatorProvenInsight[0] !== 30
                              ) {
                                const reliability_advanced =
                                  props.insightDetails.data.overview_data.reliability_advanced[
                                    index
                                  ];

                                let reliability_value = '';
                                let reliability_bg_color = '';
                                let margin_left = '';
                                if (reliability_advanced <= 3) {
                                  reliability_value = t(
                                    'details.attribute.graph.detail.indicator.reliability.low'
                                  );
                                  reliability_bg_color = '#F3674A';
                                  margin_left = '3px';
                                } else if (4 <= reliability_advanced && reliability_advanced <= 6) {
                                  reliability_value = t(
                                    'details.attribute.graph.detail.indicator.reliability.medium'
                                  );
                                  reliability_bg_color = '#FFC000';
                                  margin_left = '-9px';
                                } else if (7 <= reliability_advanced) {
                                  reliability_value = t(
                                    'details.attribute.graph.detail.indicator.reliability.high'
                                  );
                                  reliability_bg_color = '#269325';
                                  margin_left = '1px';
                                }
                                return (
                                  <div className="indicator-view">
                                    <div className="indicator-title">{attribute}</div>
                                    <div id={'reliability-indicator-download' + index}></div>
                                    <div className="reliability-value">
                                      <div
                                        className="reliability-badge-download"
                                        style={{ background: reliability_bg_color }}
                                      >
                                        <p>{reliability_advanced}</p>
                                      </div>
                                      <div
                                        className="reliability-p"
                                        style={{ marginLeft: margin_left }}
                                      >
                                        {reliability_value}
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        )}
                    </div>
                  ) : null}

                  <div className="graph-detail-view">
                    <h4>{t('details.attribute.graph.detail.heading')}</h4>
                    <p>
                      {t(
                        `details.attribute.graph.detail.desc.${
                          graphViewToggle ? 'advance' : 'basic'
                        }.${props.insightDetails.data.campaign_attribute_type}.desc1`
                      )}
                    </p>
                    <p>
                      <span className="heading">{t('details.attribute.graph.detail.xaxis')}</span>
                      {props.insightDetails.data.title}
                    </p>
                    <p>
                      <span className="heading">{t('details.attribute.graph.detail.yaxis')}</span>
                      { isBLSKpi ? props.insightDetails.kpi :
                        t(isEffectiveness ? 'Predicted impact on the Effectiveness (%)' : isVolume ? 'Predicted impact on the Volume (%)' : 'details.attribute.graph.detail.yaxis.value')}
                    </p>
                    <p>
                      <span className="heading">{t('details.attribute.info.heading.impact')}</span>
                      <span>
                        {
                        isBLSKpi ? 
                        t(
                          props.insightDetails.data.campaign_attribute_type === 'continuous' ?
                          !graphViewToggle ? 
                           t('graph.view.toggle1')
                          : t('graph.view.toggle2')
                        : (
                          !graphViewToggle ? 
                          t('selected.dataset.toggle1')
                         : t('selected.dataset.toggle2')
                        )
                           )
                        :
                      isEffectiveness ? t(
                        props.insightDetails.data.campaign_attribute_type === 'continuous' ? 
                        (!graphViewToggle ? contBasicEffect : contAdvanceEffect) : (!graphViewToggle ? catBasicEffect : catAdvanceEffect)
                      ) : isVolume ? t(
                        props.insightDetails.data.campaign_attribute_type === 'continuous' ? 
                        (!graphViewToggle ? contBasicVolume : contAdvanceVolume) : (!graphViewToggle ? catBasicVolume : catAdvanceVolume)
                      ) :
                        t(
                          `details.attribute.graph.detail.desc.${
                            graphViewToggle ? 'advance' : 'basic'
                          }.${props.insightDetails.data.campaign_attribute_type}.desc2`
                        )}
                      </span>
                    </p>
                    {props.insightDetails.data.visualisation_type === 'regression_line' && (
                      !isBLSKpi &&
                      <p>
                        <span className="heading">
                          {t('details.attribute.info.heading.legend')}
                        </span>
                        <span>
                          {
                            isEffectiveness ? (
                              !graphViewToggle ? legendBasicEffect : legendAdvanceEffect
                            ) : isVolume ? (                          
                              !graphViewToggle ? legendBasicVolume : legendAdvanceVolume
                              ) :
                          t(
                            `details.attribute.graph.detail.desc.${
                              graphViewToggle ? 'advance' : 'basic'
                            }.${props.insightDetails.data.campaign_attribute_type}.desc3`
                          )}
                        </span>
                      </p>
                    )}
                    {((props.insightDetails.data.visualisation_type === 'regression_line' &&
                      (graphViewToggle || !graphViewToggle)) ||
                      (props.insightDetails.data.visualisation_type !== 'regression_line' &&
                        !graphViewToggle)) && (
                      <p className="tip">
                        <span className="heading">{t('details.attribute.info.heading.tip')}</span>
                        <span>
                          {t(
                            `details.attribute.graph.detail.desc.${
                              graphViewToggle ? 'advance' : 'basic'
                            }.${props.insightDetails.data.campaign_attribute_type}.tip`
                          )}
                        </span>
                      </p>
                    )}
                   { !isBLSKpi && 
                    <p className="tip">
                      <span className="heading color-code-heading">
                        {t('details.attribute.info.heading.colorCodes')}
                      </span>
                      <div>
                        <div className="color-box-container">
                          <div className="color-box-download color-box-orange"> </div>
                          <span>0-3 | {t('graph.low')}</span>
                        </div>
                        <div className="color-box-container">
                          <div className="color-box-download color-box-yellow"></div>
                          <span>4-6 | {t('graph.medium')}</span>
                        </div>
                        <div className="color-box-container">
                          <div className="color-box-download color-box-green"> </div>
                          <span>7-10 | {t('graph.high')}</span>
                        </div>
                      </div>
                    </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* slide modal view ends */}
    </>
  );
};

export default AttributeDetailModal;
